import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'te',
    fullName: 'Telugu',
    nativeName: 'తెలుగు',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "సమ్థింగ్ అమేజింగ్ ఈజ్ కమింగ్",
    landing_subtitle: "ArgVoid అనేది ఒక యాప్ మరియు గేమ్ డెవలప్‌మెంట్ స్టూడియో. వేచి ఉండండి, కొత్త విషయాలు త్వరలో రానున్నాయి!",
    select_language: "భాషను ఎంచుకోండి",
    search_placeholder: "భాషలను వెతకండి...",
    terms_title: "సేవా నిబంధనలు",
    policy_title: "గోప్యతా విధానం",
    cookies_title: "కుకీ విధానం",
    terms_content: `
        <strong>1. నిబంధనల ఆమోదం</strong><br>
        ArgVoidని యాక్సెస్ చేయడం ద్వారా, ఈ సేవా నిబంధనలు ఆమోదించబడతాయి. ఈ నిబంధనలకు అంగీకరించకపోతే, సేవను ఉపయోగించకూడదు.<br><br>

        <strong>2. ప్లాట్‌ఫారమ్ వినియోగం</strong><br>
        ArgVoid మరియు దాని అప్లికేషన్‌లు సమాచార మరియు సృజనాత్మక ప్రయోజనాల కోసం "ఉన్నట్లే" అందించబడ్డాయి. సేవ తప్పనిసరిగా చట్టబద్ధమైన ప్రయోజనాల కోసం మాత్రమే ఉపయోగించాలి.<br><br>

        <strong>3. నిషేధించబడిన ప్రవర్తన</strong><br>
        సైట్ దుర్బలత్వాలను ఉపయోగించడం, స్పామింగ్ చేయడం లేదా అవస్థాపనకు అనధికారిక యాక్సెస్‌ను ప్రయత్నించడం ఖచ్చితంగా నిషేధించబడింది.<br><br>

        <strong>4. నిరాకరణ</strong><br>
        ప్లాట్‌ఫారమ్ మరియు సేవలు నోటీసు లేకుండా ఎప్పుడైనా సవరించబడవచ్చు. సేవ యొక్క సమయము లేదా లభ్యతకు సంబంధించి ఎటువంటి వారంటీ అందించబడలేదు.
    `,
    policy_content: `
        <strong>1. సమాచార సేకరణ</strong><br>
        ప్లాట్‌ఫారమ్‌కు ఈ సమయంలో వినియోగదారు ప్రమాణీకరణ లేదా ఖాతాను సృష్టించడం అవసరం లేదు. సందర్శకుల నుండి వ్యక్తిగత గుర్తింపు సమాచారం (పేర్లు లేదా ఇమెయిల్ చిరునామాలు వంటివి) చురుకుగా సేకరించబడలేదు.<br><br>

        <strong>2. వినియోగ డేటా</strong><br>
        సైట్ ట్రాఫిక్‌ను అర్థం చేసుకోవడానికి మరియు అప్లికేషన్‌లను మెరుగుపరచడానికి ప్రాథమిక, అనామక విశ్లేషణలు సేకరించబడవచ్చు. ఈ డేటా వ్యక్తిగత వినియోగదారు గుర్తింపులకు లింక్ చేయబడలేదు.<br><br>

        <strong>3. మూడవ పక్ష సేవలు</strong><br>
        హోస్టింగ్ మరియు అనలిటిక్స్ సేవల కోసం థర్డ్-పార్టీ ప్రొవైడర్లు ఉపయోగించబడవచ్చు. ఈ సంబంధిత ప్రొవైడర్ల గోప్యతా పద్ధతులు వారి మౌలిక సదుపాయాలపై ప్రాసెస్ చేయబడిన అనామక డేటాను నియంత్రిస్తాయి.<br><br>

        <strong>4. డేటా సెక్యూరిటీ</strong><br>
        ప్లాట్‌ఫారమ్‌ను రక్షించడానికి సహేతుకమైన భద్రతా చర్యలు అమలు చేయబడతాయి. అయితే, ఇంటర్నెట్ ద్వారా ప్రసారం చేసే ఏ పద్ధతి పూర్తిగా సురక్షితం కాదు.<br><br>
    `,
    cookies_content: `
        <strong>1. కుక్కీలు మరియు స్థానిక నిల్వ అంటే ఏమిటి?</strong><br>
        కుక్కీలు మరియు బ్రౌజర్ స్థానిక నిల్వ అనేది సందర్శనల అంతటా కాన్ఫిగరేషన్ ప్రాధాన్యతలను గుర్తుంచుకోవడానికి పరికరంలో నిల్వ చేయబడిన చిన్న డేటా ఫైల్‌లు.<br><br>

        <strong>2. వినియోగ ప్రయోజనం</strong><br>
        కాన్ఫిగరేషన్ సెట్టింగ్‌లను సేవ్ చేయడానికి బ్రౌజర్ లోకల్ స్టోరేజ్ ఖచ్చితంగా ఉపయోగించబడుతుంది, ఉదాహరణకు:<br>
        - భాషా ప్రాధాన్యతలు<br>
        - వినియోగదారు ఇంటర్‌ఫేస్ కాన్ఫిగరేషన్ (ఉదా., లేఅవుట్ లేదా థీమ్ సెట్టింగ్‌లు)<br>
        - తాత్కాలిక అప్లికేషన్ కాష్<br><br>

        <strong>3. </strong><br> ట్రాకింగ్ లేదు
        కుకీలు మరియు స్థానిక నిల్వ ప్రకటనలు లేదా మూడవ పక్షం ట్రాకింగ్ ప్రయోజనాల కోసం ఉపయోగించబడవు. ప్లాట్‌ఫారమ్.<br><br> యొక్క ప్రధాన కార్యాచరణ కోసం నిల్వ చేయబడిన మొత్తం డేటా ఖచ్చితంగా ఉంటుంది

        <strong>4. కంట్రోల్</strong><br>
        బ్రౌజర్ సెట్టింగ్‌ల ద్వారా ఎప్పుడైనా బ్రౌజర్ డేటాను క్లియర్ చేయవచ్చు, ఇది ఏదైనా స్థానిక కాన్ఫిగరేషన్‌లను రీసెట్ చేస్తుంది.
    `,
    cookie_consent_text: "మీ సెషన్‌ను సక్రియంగా ఉంచడం, మీ భాష ప్రాధాన్యతను సేవ్ చేయడం మరియు ఇతర అనుకూల కాన్ఫిగరేషన్‌లు వంటి వెబ్‌సైట్ ఫంక్షన్‌లను సరిగ్గా నిర్ధారించడానికి మేము ప్రాథమిక కుక్కీలను ఉపయోగిస్తాము.",
    read_policy: "కుకీ పాలసీని చదవండి",
    support_title: "మద్దతును సంప్రదించండి",
    support_subject_label: "విషయం",
    support_message_label: "సందేశం",
    support_submit_button: "సందేశం పంపండి",
    support_hint: "గమనిక: ఇది సందేశాన్ని పంపడానికి మీ డిఫాల్ట్ ఇమెయిల్ అప్లికేషన్‌ను తెరుస్తుంది.",
    support_success_msg: "మీ ఇమెయిల్ యాప్‌ని తెరుస్తోంది...",
    support_error_msg: "సందేశాన్ని పంపడంలో విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.",
    explorer_title: "అన్వేషకుడు",
    history_title: "చరిత్ర",
    animation_title: "యానిమేషన్",
    config_title: "ఆకృతీకరణ",
    tool_mouse: "ఎంచుకోండి (Ctrl+M)",
    tool_brush: "బ్రష్ (Ctrl+B)",
    tool_brush_mode: "టోగుల్ మోడ్ (ఘన/క్లియర్)",
    tool_eraser: "ఎరేజర్ (Ctrl+E)",
    tool_brush_size: "బ్రష్ పరిమాణాన్ని సర్దుబాటు చేయండి",
    tool_bucket: "పూరించండి (Ctrl+F)",
    tool_eyedropper: "ఐడ్రాపర్",
    tool_grid: "గ్రిడ్ (Ctrl+Shift+B)",
    tool_rotate: "తిప్పండి (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "ఫ్లిప్ V (Ctrl+Shift+V)",
    tool_transpose: "బదిలీ చేయండి (Ctrl+Shift+T)",
    label_width: "వెడల్పు",
    label_height: "ఎత్తు",
    label_frames: "ఫ్రేమ్‌ల సంఖ్య",
    label_animation: "యానిమేషన్ శైలి",
    label_background_color: "నేపథ్య రంగు",
    label_interval: "ఇంటర్వెల్",
    tool_anim_config: "యానిమేషన్ కాన్ఫిగరేషన్",
    label_new_width: "కొత్త వెడల్పు",
    label_new_height: "కొత్త ఎత్తు",
    label_apply: "దరఖాస్తు చేసుకోండి",
    label_colors: "రంగులు",
    label_size: "పరిమాణం",
    label_tolerance: "సహనం",
    val_horizontal: "అడ్డంగా",
    val_vertical: "నిలువు",
    val_sequence: "క్రమం",
    val_bounce: "బౌన్స్",
    val_random: "యాదృచ్ఛికంగా",
    val_solid: "ఘనమైనది",
    val_clear: "క్లియర్",
    action_add_sheet: "కొత్త షీట్",
    action_import: "దిగుమతి",
    action_export: "ఎగుమతి చేయండి",
    action_sort_projects: "క్రమబద్ధీకరించు",
    sort_date_old: "పురాతన మొదటి",
    sort_date_new: "సరికొత్త మొదటిది",
    sort_name_az: "పేరు (A-Z)",
    sort_name_za: "పేరు (Z-A)",
    action_new_sprite: "కొత్త స్ప్రైట్",
    action_new_project: "కొత్త ప్రాజెక్ట్",
    modal_save_all_title: "అన్ని మార్పులను సేవ్ చేయండి",
    modal_save_all_desc: "సేవ్ చేయడానికి ఆస్తులను ఎంచుకోండి:",
    modal_save_selected: "ఎంచుకున్న వాటిని సేవ్ చేయండి",
    action_saved: "సేవ్ చేయబడింది",
    modal_create_sprite_title: "కొత్త స్ప్రైట్‌ని సృష్టించండి",
    modal_create_project_title: "కొత్త ప్రాజెక్ట్‌ని సృష్టించండి",
    modal_add_sheet_title: "కొత్త షీట్ జోడించండి",
    modal_rename_sheet_title: "షీట్ పేరు మార్చండి",
    modal_rename_sprite_title: "స్ప్రైట్ పేరు మార్చండి",
    modal_delete_sprite_title: "స్ప్రైట్‌ను తొలగించండి",
    modal_delete_project_title: "ప్రాజెక్ట్‌ను తొలగించండి",
    modal_delete_sheet_title: "షీట్‌ను తొలగించండి",
    placeholder_sprite_name: "పేరు",
    placeholder_project_name: "పేరు",
    placeholder_sheet_name: "పేరు",
    placeholder_new_name: "కొత్త పేరు",
    action_create: "సృష్టించు",
    action_add: "జోడించు",
    action_rename: "పేరు మార్చండి",
    action_duplicate: "నకిలీ",
    action_delete: "తొలగించు",
    action_cancel: "రద్దు చేయి",
    confirm_delete_sprite: "మీరు ఖచ్చితంగా ఈ స్ప్రైట్‌ని తొలగించాలనుకుంటున్నారా?",
    confirm_delete_project: "మీరు ఖచ్చితంగా ఈ ప్రాజెక్ట్‌ను తొలగించాలనుకుంటున్నారా? అన్ని స్ప్రిట్‌లు తీసివేయబడతాయి.",
    confirm_delete_sheet: "మీరు ఖచ్చితంగా ఈ షీట్‌ని తొలగించాలనుకుంటున్నారా?",
    err_select_sprite: "దయచేసి ముందుగా స్ప్రైట్‌ని ఎంచుకోండి.",
    err_select_project: "దయచేసి ముందుగా ప్రాజెక్ట్‌ను ఎంచుకోండి.",
    err_name_empty: "పేరు ఖాళీగా ఉండకూడదు.",
    err_sprite_exists: "ఆ పేరుతో ఒక స్ప్రైట్ ఇప్పటికే ఉంది.",
    err_project_exists: "ఆ పేరుతో ఒక ప్రాజెక్ట్ ఇప్పటికే ఉంది.",
    err_no_content: "సేవ్ చేయడానికి కంటెంట్ లేదు.",
    err_no_changes: "సేవ్ చేయడానికి మార్పులు లేవు.",
    err_delete_last_sheet: "చివరి షీట్‌ను తొలగించడం సాధ్యం కాదు.",
    err_extract_frames: "ఫ్రేమ్‌లు ఏవీ సంగ్రహించబడలేదు.",
    err_indexeddb: "స్థానికంగా సేవ్ చేయడంలో విఫలమైంది. మీ బ్రౌజర్ IndexedDBకి మద్దతు ఇవ్వకపోవచ్చు.",
    msg_upload_success: "అప్‌లోడ్ విజయవంతమైంది: {0}",
    msg_upload_failed: "అప్‌లోడ్ విఫలమైంది: {0}",
    msg_save_success: "సేవ్ చేయడం విజయవంతమైంది.",
    msg_saving: "సేవ్ చేస్తోంది...",
    msg_multi_save_result: "{0} ఆస్తులు సేవ్ చేయబడ్డాయి. {1} వైఫల్యాలు.",
    menu_title: "మెనూ",
    menu_save: "సేవ్ చేయండి",
    menu_save_all: "అన్నింటినీ సేవ్ చేయండి",
    menu_support: "మద్దతును సంప్రదించండి",
    label_local_storage: "స్థానిక నిల్వ",
    label_sign_in: "సైన్ ఇన్ చేయండి",
    modal_export_title: "స్ప్రైట్‌ని ఎగుమతి చేయండి",
    label_filename: "ఫైల్ పేరు",
    label_format: "ఫార్మాట్",
    action_export_confirm: "ఎగుమతి చేయండి",
};

export default translations;
